import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initializeAdSenseAds } from "./utility/googleAds";

const scrollWindowToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();

  useEffect(() => {
    scrollWindowToTop();

    const rafId = requestAnimationFrame(scrollWindowToTop);
    const timeoutId = setTimeout(scrollWindowToTop, 0);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [pathname, search, key]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      initializeAdSenseAds();
    }, 400);

    return () => clearTimeout(timeout);
  }, [pathname, search, key]);

  return null;
};

export default ScrollToTop;
